<template>
  <div class="guide-wrapper w-100">
    <!-- 列表头部 -->
    <div class="com-list-header">
      <el-form class="com-search-box" :model="form" ref="form" label-width="80px">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item>
              <el-input v-model="form.dictName" placeholder="请输入关键字"></el-input>
            </el-form-item>
          </el-col>

        </el-row>
      </el-form>

      <div class="com-head-search-btns">
        <el-button type="primary" @click="getTableList">查询</el-button>
        <el-button @click="resetForm('form')">重置</el-button>
      </div>
    </div>

    <!-- 列表内容 -->
    <div class="com-list-content">
      <div class="button">
        <el-row>
          <el-button class="el-primary-border" round @click="handleAdd('add')">
            <svg-icon icon-class="add" />&nbsp;新增栏目
          </el-button>
        </el-row>
      </div>
      <!-- 表格 -->
      <div class="table mt-20">
        <el-table ref="multipleTable" v-loading="listLoading" stripe :data="tableData">
          <el-table-column label="序号" width="50">
            <template slot-scope="scope">{{ scope.$index+1 }}</template>
          </el-table-column>
          <el-table-column label="栏目名称" show-overflow-tooltip>
            <template slot-scope="scope"><a class="m-btn mr-10"
                @click="handleProject(scope.row)">{{ scope.row.dictName}}</a></template>
          </el-table-column>
          <el-table-column prop="dictCode" label="栏目编码" show-overflow-tooltip></el-table-column>
          <el-table-column prop="createDate" label="创建时间" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{$common.formatDateString(scope.row.createDate, 'yyyy-MM-dd')}}</span>
            </template>
          </el-table-column>
          <!-- 操作 -->
          <el-table-column fixed="right" label="操作" min-width="20%">
            <template slot-scope="scope">
              <a class="m-btn mr-10" @click="handleEdit(scope.row)">编辑</a>
              <a class="m-btn mr-10 m-danger" @click="handleDelete(scope.row)">删除</a>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container paging">
          <el-pagination :current-page="listQuery.page" :page-size="listQuery.limit" :total="total" background
            layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>

    <!-- 新增 -->
    <div>
      <el-dialog title="辽博视听" @close="onCancel"
        :close-on-click-modal="false" :visible.sync="dialogVisible" :width="'30%'">
        <el-form ref="form" :model="addForm" :rules="rules">
          <!-- <el-form-item class="mb-30" prop="dictType">
            <el-input v-model="addForm.dictType" disabled placeholder="请输入栏目名称" />
          </el-form-item> -->

          <el-form-item class="mb-30" prop="dictName">
            <el-input v-model="addForm.dictName" placeholder="请输入栏目名称" />
          </el-form-item>

          <el-form-item class="mb-30" prop="dictCode">
            <el-input v-model="addForm.dictCode" placeholder="请输入栏目code" />
          </el-form-item>

          <el-form-item class="mb-30" prop="dictOrder">
            <el-input v-model="addForm.dictOrder" placeholder="请输入顺序" />
          </el-form-item>
          <el-form-item class="avatar-uploader-form" prop="chargeBy">
            <el-upload class="avatar-uploader" action="/singleMuseum/attach/upload" :disabled="operation == 'view'"
              accept=".jpg,.jpeg,.png,.JPG" :data="configData" :show-file-list="false" :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload">
              <img v-if="addForm.chargeBy" style="height:120px;object-fit:contain;" :src="addForm.chargeBy"
                class="avatar">
              <div v-else>
                <i class="el-icon-plus avatar-uploader-icon"></i>
                <div class="el-upload__text">上传封面</div>
              </div>
            </el-upload>
            <div class="tip-img" style="left: 0">建议图片大小：1600 * 900</div>
          </el-form-item>
        </el-form>
        <div class="dialog-footer tr mt-30">
          <el-button @click="onCancel">取 消</el-button>
          <el-button type="primary" :loading="loadingSave" @click="onSubmit">确 定</el-button>
        </div>
      </el-dialog>
    </div>

    <!-- 剪裁组件弹窗 -->
    <!-- <cropper-image ref="cropperRef" @uploadImgSuccess="handleUploadSuccess">
    </cropper-image> -->
  </div>
</template>

<script>
import CropperImage from "@cmp/cropper";
import { mapGetters } from 'vuex'

export default {
  components: { CropperImage },
  computed: {
    ...mapGetters(['imageTypes']),
  },
  data() {
    return {
      form: {
        dictName: '',
      },
      addForm: {
        dictType: 'video_type',
        chargeBy: '',
        pid: -1,
      },

      loadingSave: false,
      operation: 'add',
      rules: {
        dictName: [{ required: true, message: '视频栏目名称不能为空', trigger: 'blur' }],
        dictCode: [{ required: true, message: '视频栏目编码不能为空', trigger: 'blur' }],
      },

      configData: {
        tableName: 'collect'
      },
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 10
      },
      total: 0,
      tableData: [],
      dialogVisible: false
    }
  },
  methods: {
    // 项目列表
    getDicData() {
      this.tableData = []
      this.listLoading = true
      this.$http.get('collectDict/getSysDictList', { dictType: 'video_type', ...this.form, ...this.listQuery }).then(res => {
        this.listLoading = false
        if (res.data && res.data.length > 0) {
          this.tableData = res.data
          this.total = res.count
        }
      })

      // this.$http
      //   .get('/collectDict/getSelectDataByKey', { key: 'video_type' })
      //   .then(res => {
      //     this.listLoading = false
      //     if (res.success) {
      //       var result = res.result
      //       this.tableData = result
      //     } else {
      //       this.$message.error(res.message)
      //     }
      //   })
    },

    // handleUploadSuccess(result) {
    //   this.addForm.chargeBy = result.attPath
    //   this.imgUrl = ""
    //   this.cropperModel = false
    // },


    handleProject(obj) {
      this.$router.push({
        path: '/applet-management/video-type',
        query: { dictCode: obj.dictCode }
      })
    },
    handleAvatarSuccess(res) {
      if (res.success) {
        this.$message.success('上传成功')
        this.addForm.chargeBy = res.result.attPath
      } else {
        this.$message.error(res.message)
      }
    },
    //封面设置
    uploadPicture(type) {
      // if (!this.editFlag) {
      //   return
      // }
      this.imgUrl = this.addForm.chargeBy

      let option = {
        cropWidth: "345", cropHeight: "228", imgUrl: this.imgUrl
      }
      this.$refs.cropperRef.initCropper(option)
    },


    // 重置查询
    resetForm() {
      this.form = {
        dictName: '',
      }
      this.listQuery.page = 1
      this.getDicData()
    },

    // 查询
    getTableList() {
      this.listQuery.page = 1
      this.getDicData()
    },

    // 新增
    handleAdd() {
      this.dialogVisible = true
    },

    handleEdit(obj) {
      this.operation = "edit"
      this.dialogVisible = true
      this.addForm = JSON.parse(JSON.stringify(obj))
    },


    beforeAvatarUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 2
      const fileName = file.name
      const fileType = fileName.substring(fileName.lastIndexOf('.') + 1)
      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 2MB!',
          type: 'warning'
        })
        return
      }

      if (this.imageTypes.includes(fileType)) {
        return true

      } else {
        this.$message.error(
          '请上传正确的图片类型'
        )
        return false
      }
    },


    // 删除
    handleDelete(obj) {
      this.$common.confirm(
        {
          title: `是否确认删除？`,
          className: 'cus-confirm-375'
        }, () => {
          this.$http.get('collectDict/deleteSysDict', { dictId: obj.id }).then(res => {
            if (res.success) {
              this.$message.success('删除成功')
              this.getDicData()
            } else {
              this.$message.error(res.message)
            }
          })
        }
      )
    },

    onCancel() {
      this.dialogVisible = false
      this.addForm = {
        dictType: 'video_type',
        pid: -1,
        chargeBy: ''
      }
      this.$refs["form"].clearValidate()
    },

    // 表格分页
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getDicData()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getDicData()
    },

    onSubmit() {
      const self = this
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.loadingSave = true
          let url = "collectDict/addSysDict",
            method = "post"
          if (this.addForm.id) {
            url = "collectDict/updateSysDict"
            method = "get"
          }
          if (this.addForm.createDate) {
            delete this.addForm.createDate
          }
          this.$http[method](url, this.addForm).then(res => {
            this.loadingSave = false

            if (res.success) {
              this.$message.success({
                message: this.addForm.id ? '视频栏目修改成功' : '视频栏目新增成功',
                duration: 500,
                onClose() {
                  self.dialogVisible = false
                  self.addForm = {}
                  self.getDicData()
                }
              })
            } else {
              this.$message.error(this.addForm.id ? '视频栏目修改失败' : '视频栏目新增失败')
            }
          }).catch(err => {
            this.loadingSave = false
          })
        } else {
          return false;
        }
      });
    },

    keydown(event) {
      if (event.keyCode == '13') {
        this.getTableList()
      }
    },

  },
  created() {
    // this.getData()

    this.getDicData()

    window.addEventListener('keyup', this.keydown)

  }
}
</script>

<style lang="scss" scoped>
.guide-wrapper {
  /deep/ .el-form-item {
    .el-form-item__content {
      margin-left: 0 !important;
    }

    &.avatar-uploader-form {
      display: flex;
      flex-direction: column;
      .tip-img {
        left: 0;
      }
      .uploader-form {
        position: relative;
        width: 258px;
        height: 194px;
        display: flex;
        cursor: pointer;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border: 1px dashed #8c939d;

        img {
          width: 100%;
          height: 100%;
        }
        .tip-img {
          left: 0;
        }

        i {
          font-size: 34px;
        }
      }
      /deep/ .el-form-item__content {
        margin-left: 0 !important;
      }

      .avatar-uploader {
        width: 50%;
        border: 1px dashed #8c939d;
        height: 120px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .el-upload {
          width: 100%;
        }
        .el-icon-plus {
          font-size: 20px;
        }

        .el-upload__text {
          line-height: 1;
        }
      }
    }
  }
}
</style>